export const GuessMeLogEvent = {
  guessMeGuestReplyDetailMakeOwnClicked: {
    ga: 'guess_me_guest_reply_detail_make_own',
    amp: 'Guess Me Guest Reply Detail - Make Own Clicked',
  }, // [나를 맞혀봐 - 게스트 응답 디테일] ‘나도 퀴즈 만들기’ 버튼 클릭
  guessMeGuestReplyDetailViewed: { ga: 'guess_me_guest_reply_visit', amp: 'Guess Me Guest Reply Detail - Viewed' }, // [나를 맞혀봐 - 게스트 응답 디테일] 디테일 화면 조회
  guessMeHostQuizDetailShareKakaoClicked: {
    ga: 'guess_me_host_quiz_detail_kakao_share_clicked',
    amp: 'Guess Me Host Quiz Detail - Share Kakao Clicked',
  }, // [나를 맞혀봐 - 호스트 퀴즈 디테일] 카카오 공유 클릭
  guessMeHostQuizDetailShareURLClicked: {
    ga: 'guess_me_host_quiz_detail_url_share_clicked',
    amp: 'Guess Me Host Quiz Detail - Share URL Clicked',
  }, // [나를 맞혀봐 - 호스트 퀴즈 디테일] 링크 복사 클릭
  guessMeHostQuizDetailShareWebshareClicked: {
    ga: 'guess_me_host_quiz_detail_web_share_clicked',
    amp: 'Guess Me Host Quiz Detail - Share Webshare Clicked',
  }, // [나를 맞혀봐 - 호스트 퀴즈 디테일] 웹쉐어 API 클릭
  guessMeHostQuizDetailViewed: { ga: 'guess_me_host_quiz_detail_visit', amp: 'Guess Me Host Quiz Detail - Viewed' }, // [나를 맞혀봐 - 호스트 퀴즈 디테일] 디테일 화면 조회
  guessMeHostReplyDetailViewed: { ga: 'guess_me_host_reply_detail_visit', amp: 'Guess Me Host Reply Detail - Viewed' }, // [나를 맞혀봐 - 호스트 응답 디테일] 디테일 화면 조회
  guessMeQuizCreateAnswerSelectClicked: {
    ga: 'guess_me_quiz_create_answer_select',
    amp: 'Guess Me Quiz Create - Answer Select Clicked',
  }, // [나를 맞혀봐 - 퀴즈 생성] 답변 선택
  guessMeQuizCreateChangeQuestionClicked: {
    ga: 'guess_me_quiz_create_change_question',
    amp: 'Guess Me Quiz Create - Change Question Clicked',
  }, // [나를 맞혀봐 - 퀴즈 생성] 질문 바꾸기 클릭
  guessMeQuizCreateNameEntryViewed: {
    ga: 'guess_me_quiz_create_name_entry_visit',
    amp: 'Guess Me Quiz Create - Name Entry Viewed',
  }, // [나를 맞혀봐 - 퀴즈 생성] 이름 입력(인트로) 화면 표시
  guessMeQuizCreateQuestionnaireViewed: {
    ga: 'guess_me_quiz_create_questionnaire_visit',
    amp: 'Guess Me Quiz Create - Questionnaire Viewed',
  }, // [나를 맞혀봐 - 퀴즈 생성] 질문지 표시
  guessMeQuizCreateQuizCreateSubmit: {
    ga: 'guess_me_quiz_create_submit',
    amp: 'Guess Me Quiz Create - Quiz Create Submit',
  }, // [나를 맞혀봐 - 퀴즈 생성] 퀴즈 생성 완료
  guessMeReplyCreateAnswerSelectClicked: {
    ga: 'guess_me_reply_create_answer_select',
    amp: 'Guess Me Reply Create - Answer Select Clicked',
  }, // [나를 맞혀봐 - 응답 생성] 답변 선택
  guessMeReplyCreateNameEntryViewed: {
    ga: 'guess_me_reply_create_name_entry_visit',
    amp: 'Guess Me Reply Create - Name Entry Viewed',
  }, // [나를 맞혀봐 - 응답 생성] 이름 입력(인트로) 화면 표시
  guessMeReplyCreateQuestionnaireViewed: {
    ga: 'guess_me_reply_create_questionnaire_visit',
    amp: 'Guess Me Reply Create - Questionnaire Viewed',
  }, // [나를 맞혀봐 - 응답 생성] 질문지 표시
  guessMeReplyCreateReplyCreateSubmit: {
    ga: 'guess_me_reply_create_submit',
    amp: 'Guess Me Reply Create - Reply Create Submit',
  }, // [나를 맞혀봐 - 응답 생성] 응답 생성 완료
  homeGuessMeClicked: { ga: 'home_Image_game_click', amp: 'Home - Guess Me Clicked' }, // [홈 탭] 나를 맞혀봐 배너 클릭
  homeGuessMeImpression: { ga: 'impression', amp: 'Home - Guess Me Impression' }, // [홈 탭] 나를 맞혀봐 배너 노출
}
